"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeasurementInfo = void 0;
exports.getMeasurementInfo = `
query($id: Int!) {
 coachTrainee(id: $id) {
  nextMeasurement {
    week
    date {
        iso8601
      }
    }
  
  lastMeasurement {
    createdAt
    absoluteWeek
    height
    weight
    shoulders
    waist
    breast
    legs
    photoFront
    photoSide
    photoBack
    }  
  }
}
`;
//# sourceMappingURL=getMeasurementInfo.js.map